<p>home works!</p>
<router-outlet></router-outlet>
<!--<a>[routerLink] = {{routerLink}}</a>-->
